export default function getPrefixedScopedSlots( prefix, scopedSlots ) {
	return Object.keys( scopedSlots )
	.filter( k => k.startsWith( prefix ) )
	.reduce( ( obj, k ) => {
		obj[k.replace( prefix, "" )] = scopedSlots[k];

		return obj;
	}, {} );
}
